import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const getContractTypeByContractStatus = (fields, contractStatusList) => {
  let result = {
    options: [],
    value: ''
  };

  const options = contractStatusList.map((x) => {
    return { id: x.id, name: x.code };
  });

  if (fields && fields.contractStatusId) {
    result.value = fields.contractStatusId;

    const contractStatusCode = options.filter(
      (x) => x.id === fields.contractStatusId
    )[0].name;
    switch (contractStatusCode) {
      case 'PENDING_APPROVAL':
        result.options = options.filter((x) =>
          [
            'PENDING_APPROVAL',
            'CANCELLED',
            'REJECTED',
            'PENDING_INSTALLATION'
          ].includes(x.name)
        );
        break;
      case 'CANCELLED':
        result.options = options.filter((x) => ['CANCELLED'].includes(x.name));
        break;
      case 'REJECTED':
        result.options = options.filter((x) => ['REJECTED'].includes(x.name));
        break;
      case 'PENDING_INSTALLATION':
        if (fields.contractCodePrefix === 'R') {
          result.options = options.filter((x) =>
            ['PENDING_INSTALLATION', 'CANCELLED'].includes(x.name)
          );
        } else {
          result.options = options.filter((x) =>
            [
              'PENDING_INSTALLATION',
              'ACTIVE_PENDING_PAYMENT',
              'CANCELLED'
            ].includes(x.name)
          );
        }
        break;
      case 'ACTIVE_PENDING_PAYMENT':
        result.options = options.filter((x) =>
          ['ACTIVE_PENDING_PAYMENT'].includes(x.name)
        );
        break;
      case 'ACTIVE':
        result.options = options.filter((x) =>
          [
            'ACTIVE',
            'TEMPORARY_SUSPENSION',
            'INACTIVE_WITH_NOTICE',
            'INACTIVE_PENDING_UNINSTALLATION',
            'INACTIVE_REINSTALLATION',
            'INACTIVE_HOLDER_CHANGE'
          ].includes(x.name)
        );
        break;
      case 'ACTIVE_REINSTALLATION':
        result.options = options.filter((x) =>
          ['ACTIVE_REINSTALLATION'].includes(x.name)
        );
        break;
      case 'TEMPORARY_SUSPENSION':
        result.options = options.filter((x) =>
          ['TEMPORARY_SUSPENSION', 'ACTIVE'].includes(x.name)
        );
        break;
      case 'SERVICE_CUT':
        result.options = options.filter((x) =>
          ['SERVICE_CUT'].includes(x.name)
        );
        break;
      case 'SERVICE_AND_BILLING_CUT':
        result.options = options.filter((x) =>
          [
            'SERVICE_AND_BILLING_CUT',
            'INACTIVE_PENDING_UNINSTALLATION',
            'INACTIVE_WITH_NOTICE'
          ].includes(x.name)
        );
        break;
      case 'INACTIVE_PENDING_UNINSTALLATION':
        result.options = options.filter((x) =>
          ['INACTIVE_PENDING_UNINSTALLATION', 'INACTIVE'].includes(x.name)
        );
        break;
      case 'INACTIVE':
        result.options = options.filter((x) => ['INACTIVE'].includes(x.name));
        break;
      case 'INACTIVE_WITH_NOTICE':
        result.options = options.filter((x) =>
          ['INACTIVE_WITH_NOTICE', 'ACTIVE'].includes(x.name)
        );
        break;
      case 'INACTIVE_REINSTALLATION':
        result.options = options.filter((x) =>
          ['INACTIVE_REINSTALLATION'].includes(x.name)
        );
        break;
      case 'INACTIVE_HOLDER_CHANGE':
        result.options = options.filter((x) =>
          ['INACTIVE_HOLDER_CHANGE'].includes(x.name)
        );
        break;
      default:
        result.options = [];
    }
  } else {
    result.options = options.filter((x) => x.name === 'PENDING_APPROVAL');
    result.value = result.options[0].id;
  }

  return result;
};

const getContractTypeCode = ({ fields, contractTypeList }) => {
  if (fields && fields.contractTypeId) {
    const contractTypeName = contractTypeList.filter(
      (x) => x.id === fields.contractTypeId
    )[0].name;

    if (
      contractTypeName.indexOf('DESINSTALACIÓN DE SERVICIO DE RASTREO') !==
        -1 ||
      contractTypeName.indexOf('DESINSTALACION DE SERVICIO DE RASTREO') !== -1
    ) {
      return 'UNINSTALLATION_AVL';
    } else if (
      contractTypeName.indexOf('RESCISIÓN ANTICIPADA') !== -1 ||
      contractTypeName.indexOf('RESCISION ANTICIPADA') !== -1
    ) {
      return 'EARLY_CONTRACT_TERMINATION';
    } else if (
      contractTypeName.indexOf('REACTIVACIÓN SERVICIO') !== -1 ||
      contractTypeName.indexOf('REACTIVACION SERVICIO') !== -1
    ) {
      return 'REACTIVATION_AVL';
    } else if (
      contractTypeName.indexOf('VERIFICACIÓN RASTREO') !== -1 ||
      contractTypeName.indexOf('VERIFICACION RASTREO') !== -1
    ) {
      return 'VERIFICATION_AVL';
    } else if (
      contractTypeName.indexOf('VERIFICACIÓN DOMÓTICA') !== -1 ||
      contractTypeName.indexOf('VERIFICACION DOMOTICA') !== -1
    ) {
      return 'VERIFICATION_DOMOTIC';
    } else if (
      contractTypeName.indexOf('VERIFICACIÓN ALARMA') !== -1 ||
      contractTypeName.indexOf('VERIFICACION ALARMA') !== -1
    ) {
      return 'VERIFICATION_ALARM';
    } else if (contractTypeName.indexOf('INSTALACIÓN DE RASTREO') !== -1) {
      return 'AVL_INSTALLATION';
    } else if (
      contractTypeName.indexOf('SERVICIO DE INSTALACIÓN CÁMARA') !== -1 ||
      contractTypeName.indexOf('SERVICIO DE INSTALACION CÁMARA') !== -1
    ) {
      return 'CAMERA_INSTALLATION';
    } else if (
      contractTypeName.indexOf('SERVICIO DE INSTALACIÓN ALARMA') !== -1 ||
      contractTypeName.indexOf('SERVICIO DE INSTALACION ALARMA') !== -1
    ) {
      return 'ALARM_INSTALLATION';
    } else if (contractTypeName.indexOf('ALARMA') !== -1) {
      return 'ALARM';
    } else if (
      contractTypeName.indexOf('DOMÓTICA') !== -1 ||
      contractTypeName.indexOf('DOMOTICA') !== -1
    ) {
      return 'DOMOTIC';
    } else if (contractTypeName.indexOf('VENTA') !== -1) {
      return 'SELL';
    } else if (
      contractTypeName.indexOf('CÁMARA') !== -1 ||
      contractTypeName.indexOf('CAMARA') !== -1
    ) {
      return 'CAMERA';
    } else if (
      contractTypeName.indexOf('TRANSMISIÓN DE DATOS') !== -1 ||
      contractTypeName.indexOf('TRANSMISION DE DATOS') !== -1
    ) {
      return 'DATA-TRANSMISSION';
    } else if (contractTypeName.indexOf('CONTROL FUNCIONARIO') !== -1) {
      return 'EMPLOYEE-CONTROL';
    } else if (contractTypeName.indexOf('RASTREO') !== -1) {
      return 'AVL';
    } else if (contractTypeName.indexOf('ROAMING') !== -1) {
      return 'ROAMING';
    }
  }
};

const getCustomerContractList = ({
  customerContractList,
  contractTypeList
}) => {
  return customerContractList
    .map((x) => {
      const contractType = contractTypeList.filter(
        (y) => y.id === x.contractTypeId
      )[0];

      if (contractType.price) {
        return {
          id: x.id,
          name: `${x.itemName || ''} (${contractType.name})`
        };
      }
    })
    .filter((x) => x);
};

const getContractCodePrefix = ({ fields, contractTypeList }) => {
  if (fields && fields.contractTypeId) {
    return contractTypeList.filter((x) => x.id === fields.contractTypeId)[0]
      .contractCodePrefix;
  } else {
    return '';
  }
};

const Contract = ({
  fields,
  user,
  contractStatusList,
  contractTypeList,
  locatorTypeList,
  customerContactList,
  employeeList,
  customerContractList
}) => {
  return [
    {
      name: 'searchCustomer',
      validation: yup
        .string()
        .trim()
        .nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.searchCustomer ? fields.searchCustomer : '',
      enabled:
        fields &&
        fields.ContractStatus &&
        fields.ContractStatus.code === 'ACTIVE_HOLDER_CHANGE'
          ? true
          : false
    },
    {
      name: 'customer',
      validation:
        fields &&
        fields.ContractStatus &&
        fields.ContractStatus.code === 'ACTIVE_HOLDER_CHANGE'
          ? yup
              .string()
              .trim()
              .required('fieldRequired')
          : yup
              .string()
              .trim()
              .nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.customer ? fields.customer : '',
      readonly: true,
      fullWidth: true,
      enabled:
        fields &&
        fields.ContractStatus &&
        fields.ContractStatus.code === 'ACTIVE_HOLDER_CHANGE'
          ? true
          : false
    },
    {
      name: 'contractTypeId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value: fields && fields.contractTypeId ? fields.contractTypeId : '',
      options: contractTypeList,
      readonly: fields && fields.id,
      /*
                      fields &&
                      fields.ContractStatus &&
                      ['PENDING_APPROVAL', 'PENDING_INSTALLATION'].includes(
                          fields.ContractStatus.code
                      )
                          ? false
                          : true,*/
      fullWidth: true
    },
    {
      name: 'contractStatusId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value: getContractTypeByContractStatus(fields, contractStatusList).value,
      options: getContractTypeByContractStatus(fields, contractStatusList)
        .options,
      fullWidth: true,
      enabled:
        fields &&
        (fields.id ||
          (fields.ContractStatus &&
            fields.ContractStatus.code === 'ACTIVE_REINSTALLATION'))
          ? true
          : false
    },
    {
      name: 'contractCodePrefix',
      validation: yup
        .string()
        .trim()
        .nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value:
        fields && fields.contractCodePrefix
          ? fields.contractCodePrefix
          : getContractCodePrefix({ fields, contractTypeList }),
      //readonly: true,
      enabled: fields && fields.contractTypeId
    },
    {
      name: 'contractCode',
      validation: yup
        .string()
        .trim()
        .nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.contractCode ? fields.contractCode : '',
      readonly: fields && fields.id ? true : false,
      enabled: true
    },
    {
      name: 'locatorTypeId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value: fields && fields.locatorTypeId ? fields.locatorTypeId : '',
      options: locatorTypeList.map((x) => {
        return { id: x.id, name: x.code };
      }),
      enabled:
        fields &&
        fields.contractTypeId &&
        contractTypeList &&
        ['AVL'].includes(getContractTypeCode({ fields, contractTypeList }))
    },
    {
      name: 'beginDate',
      validation: yup.date().required('fieldRequired'),
      type: FormFieldType.DATE,
      value: fields && fields.beginDate ? fields.beginDate : new Date(),
      enabled:
        fields && fields.contractStatusId
          ? contractStatusList.filter(
              (x) =>
                x.id === fields.contractStatusId &&
                [
                  'PENDING_INSTALLATION',
                  'ACTIVE_PENDING_PAYMENT',
                  'ACTIVE',
                  'ACTIVE_REINSTALLATION',
                  'ACTIVE_HOLDER_CHANGE',
                  'INACTIVE'
                ].includes(x.code)
            ).length
          : false,
      readonly:
        fields && fields.contractStatusId
          ? !contractStatusList.filter(
              (x) =>
                x.id === fields.contractStatusId &&
                ['PENDING_INSTALLATION'].includes(x.code)
            ).length
          : true
    },
    {
      name: 'renewalDate',
      validation: yup.date().nullable(true),
      type: FormFieldType.DATE,
      value: fields && fields.renewalDate ? fields.renewalDate : null,
      enabled: fields && fields.id && fields.beginDate,
      readonly: false
    },
    {
      name: 'customerContractId',
      validation: [
        'ROAMING',
        'REACTIVATION_AVL',
        'VERIFICATION_AVL',
        'UNINSTALLATION_AVL',
        'EARLY_CONTRACT_TERMINATION'
      ].includes(getContractTypeCode({ fields, contractTypeList }))
        ? yup.string().required('fieldRequired')
        : yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.customerContractId ? fields.customerContractId : '',
      options: getCustomerContractList({
        customerContractList,
        contractTypeList
      }),
      enabled:
        fields &&
        [
          'ROAMING',
          'REACTIVATION_AVL',
          'VERIFICATION_AVL',
          'UNINSTALLATION_AVL',
          'EARLY_CONTRACT_TERMINATION'
        ].includes(getContractTypeCode({ fields, contractTypeList }))
    },
    {
      name: 'itemName',
      validation: yup
        .string()
        .trim()
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.itemName ? fields.itemName : '',
      readonly: fields && fields.beginDate && fields.itemName,
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'identification',
      validation: yup
        .string()
        .trim()
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.identification ? fields.identification : '',
      readonly: fields && fields.beginDate && fields.identification,
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'color',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value: fields && fields.color ? fields.color : '',
      options: [
        'WHITE',
        'BLACK',
        'RED',
        'BLUE',
        'GREEN',
        'YELLOW',
        'GRAY',
        'BEIGE',
        'BROWN',
        'BURGUNDY',
        'CYAN',
        'LILAC',
        'MUSTARD',
        'ORANGE',
        'PINK',
        'TEAL'
      ].map((x) => {
        return { id: x, name: x };
      }),
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'brand',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.brand ? fields.brand : '',
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'model',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.model ? fields.model : '',
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'year',
      validation: yup
        .number()
        .typeError('fieldNumeric')
        .nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.year ? fields.year : '',
      enabled: ['AVL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'firstname',
      validation: yup
        .string()
        .trim()
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.firstname ? fields.firstname : '',
      readonly: fields && fields.id && fields.firstname,
      enabled: ['EMPLOYEE-CONTROL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'surnames',
      validation: yup
        .string()
        .trim()
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.surnames ? fields.surnames : '',
      readonly: fields && fields.id && fields.surnames,
      enabled: ['EMPLOYEE-CONTROL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'document',
      validation: yup
        .string()
        .trim()
        .required('fieldRequired'),
      type: FormFieldType.TEXT_FIELD,
      value: fields && fields.document ? fields.document : '',
      readonly: fields && fields.id && fields.document,
      enabled: ['EMPLOYEE-CONTROL'].includes(
        getContractTypeCode({ fields, contractTypeList })
      )
    },
    {
      name: 'sellerEmployeeId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value: fields && fields.sellerEmployeeId ? fields.sellerEmployeeId : '',
      options: employeeList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .filter((x) => x),
      fullWidth: true,
      enabled: user && user.scopes.includes('admin:contracts')
    },
    {
      name: 'hasSellerUnmanagedSignaturePenaltyFee',
      validation: yup.boolean(),
      type: FormFieldType.CHECKBOX,
      value:
        fields && fields.hasSellerUnmanagedSignaturePenaltyFee != null
          ? fields.hasSellerUnmanagedSignaturePenaltyFee
          : true,
      readonly: fields?.id && !user?.scopes.includes('admin:contracts'),
      enabled: [
        'AVL',
        'CAMERA',
        'DOMOTIC',
        'CLOUD-VIDEOS-15-DAYS',
        'ALARM'
      ].includes(getContractTypeCode({ fields, contractTypeList }))
    },
    {
      name: 'hasReferralComission',
      validation: yup.boolean(),
      type: FormFieldType.CHECKBOX,
      value:
        fields && fields.hasReferralComission != null
          ? fields.hasReferralComission
          : true,
      readonly: fields?.id && !user?.scopes.includes('admin:contracts'),
      enabled: [
        'AVL',
        'CAMERA',
        'DOMOTIC',
        'CLOUD-VIDEOS-15-DAYS',
        'ALARM'
      ].includes(getContractTypeCode({ fields, contractTypeList }))
    },
    {
      name: 'plannedInstallationDate',
      validation: yup.date(),
      type: FormFieldType.DATE,
      value:
        fields && fields.plannedInstallationDate
          ? fields.plannedInstallationDate
          : new Date()
    },
    {
      name: 'installationAddress',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_AREA,
      value:
        fields && fields.installationAddress ? fields.installationAddress : ''
    },
    {
      name: 'comments',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_AREA,
      value: fields && fields.comments ? fields.comments : '',
      fullWidth: true,
      readonly: true
    },
    {
      name: 'newComment',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_AREA,
      fullWidth: true,
      value: fields && fields.newComment ? fields.newComment : ''
    },
    {
      name: 'installationTechnicianEmployeeId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.installationTechnicianEmployeeId
          ? fields.installationTechnicianEmployeeId
          : '',
      options: employeeList
        .map((x) => {
          if (x.department === 'INSTALLATION_TECHNICIAN') {
            return {
              id: x.id,
              name: `${x.firstname} ${x.surnames} ${x.document}`
            };
          }
        })
        .filter((x) => x),
      fullWidth: true
    },
    {
      name: 'holderCustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.holderCustomerContactId
          ? fields.holderCustomerContactId
          : typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'beneficiaryCustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.beneficiaryCustomerContactId
          ? fields.beneficiaryCustomerContactId
          : typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'billToCustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.billToCustomerContactId
          ? fields.billToCustomerContactId
          : customerContactList &&
            customerContactList.length === 1 &&
            typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'moneyCollectionCustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.moneyCollectionCustomerContactId
          ? fields.moneyCollectionCustomerContactId
          : typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'directives1CustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.directives1CustomerContactId
          ? fields.directives1CustomerContactId
          : typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'directives2CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.directives2CustomerContactId
          ? fields.directives2CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'directives3CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.directives3CustomerContactId
          ? fields.directives3CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'directives4CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.directives4CustomerContactId
          ? fields.directives4CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'directives5CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.directives5CustomerContactId
          ? fields.directives5CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'info1CustomerContactId',
      validation: yup.string().required('fieldRequired'),
      type: FormFieldType.SELECT,
      value:
        fields && fields.info1CustomerContactId
          ? fields.info1CustomerContactId
          : typeof customerContactList.filter(
              (x) => x.relationship === 'holder'
            )[0] !== 'undefined'
          ? customerContactList.filter((x) => x.relationship === 'holder')[0].id
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '--Seleccione--' }),
      fullWidth: true
    },
    {
      name: 'info2CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.info2CustomerContactId
          ? fields.info2CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'info3CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.info3CustomerContactId
          ? fields.info3CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'info4CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.info4CustomerContactId
          ? fields.info4CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'info5CustomerContactId',
      validation: yup.string().nullable(true),
      type: FormFieldType.SELECT,
      value:
        fields && fields.info5CustomerContactId
          ? fields.info5CustomerContactId
          : '',
      options: customerContactList
        .map((x) => {
          return {
            id: x.id,
            name: `${x.firstname} ${x.surnames} ${x.document}`
          };
        })
        .concat({ id: '', name: '-' }),
      fullWidth: true
    },
    {
      name: 'reinstallationDestinContractId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.reinstallationDestinContractId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'holderChangeDestinContractId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.holderChangeDestinContractId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'newHeadquarterCustomerId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.newHeadquarterCustomerId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'inventoryDeviceId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.inventoryDeviceId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'oldInventoryDeviceId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.oldInventoryDeviceId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'inventorySimcardId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.inventorySimcardId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    },
    {
      name: 'oldInventorySimcardId',
      validation: yup.string().nullable(true),
      type: FormFieldType.TEXT_FIELD,
      value: (fields && fields.oldInventorySimcardId) || null,
      enabled: true,
      readonly: true,
      hidden: true
    }
  ];
};

export default Contract;
